import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
export const markerSelectSlice = createSlice({
  name: 'markerSelection',
  initialState: {
    selectedData: []
  },
  reducers: {
    markerSelectionReducer: (state, action) => {
      state.selectedData = action.payload;
      return state;
    }
  }
})
// case under reducers becomes an action 
export const { markerSelectionReducer } = markerSelectSlice.actions;
export default markerSelectSlice.reducer; 
